import React, { useState, useEffect } from 'react';
import { collection, addDoc, updateDoc, deleteDoc, getDocs, doc, query, where } from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { db, storage } from '../Firebase/Firebase';
import MapShow from '../Components/mapShow'; // Asegúrate de que la ruta sea correcta
import Navbar from '../Components/NavBarAirbnbStyle';
import Footer from '../Components/footer';
import './mapAd.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NavbarMobileVersion from '../Components/NavBar/NavBarMobileVersion';

const MapAd = () => {
    const auth = getAuth();
    const userId = auth.currentUser ? auth.currentUser.uid : null;

    const [places, setPlaces] = useState([]);
    const [newPlace, setNewPlace] = useState({ nombreL: '', lat: '', lon: '', referencia: '', mainImageUrl: '' });
    const [newSpace, setNewSpace] = useState({ nombreEspacio: '', tipo: '', maxPersonas: '', imageUrls: [] });
    const [spaces, setSpaces] = useState([]);
    const [editingPlace, setEditingPlace] = useState(null);
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [selectedSpace, setSelectedSpace] = useState(null); // Añadir esta línea
    const [editingSpace, setEditingSpace] = useState(null);
    const [images, setImages] = useState([]);
    const [spaceImages, setSpaceImages] = useState([]);
    const [progress, setProgress] = useState(0);
    const [showSpaceForm, setShowSpaceForm] = useState(false);

    useEffect(() => {
        if (userId) {
            const fetchPlaces = async () => {
                const q = query(collection(db, 'lugar'), where('userId', '==', userId));
                const querySnapshot = await getDocs(q);
                const placesData = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setPlaces(placesData);
            };
            fetchPlaces();
        }
    }, [userId]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewPlace({ ...newPlace, [name]: value });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImages([file]);
    };

    const handleSpaceInputChange = (e) => {
        const { name, value } = e.target;
        setNewSpace({ ...newSpace, [name]: value });
    };

    const handleSpaceImageChange = (e) => {
        const filesArray = Array.from(e.target.files).slice(0, 2);
        setSpaceImages(filesArray);
    };

    const handleAddPlace = async () => {
        if (images.length === 0) {
            toast.error("Debes subir una imagen.");
            return;
        }
        const image = images[0];
        const storageRef = ref(storage, `imgLugares/${image.name}`);
        const uploadTask = uploadBytesResumable(storageRef, image);

        uploadTask.on('state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                setProgress(progress);
            },
            (error) => {
                console.error("Error subiendo la imagen: ", error);
            },
            async () => {
                const imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
                await savePlace(imageUrl);
            }
        );
    };

    const savePlace = async (imageUrl) => {
        try {
            const docRef = await addDoc(collection(db, 'lugar'), {
                ...newPlace,
                mainImageUrl: imageUrl,
                userId
            });
            setPlaces([...places, { ...newPlace, id: docRef.id, mainImageUrl: imageUrl, userId }]);
            setNewPlace({ nombreL: '', lat: '', lon: '', referencia: '', mainImageUrl: '' });
            setImages([]);
            setProgress(0);
        } catch (error) {
            console.error('Error agregando el documento: ', error);
        }
    };

    const handleSelectPlace = async (place) => {
        if (selectedPlace === place.id) {
            setSelectedPlace(null);
            setSpaces([]);
        } else {
            setSelectedPlace(place.id);
            const querySnapshot = await getDocs(collection(db, 'lugar', place.id, 'espacios'));
            const spacesData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setSpaces(spacesData);
            setShowSpaceForm(false);
        }
    };

    const handleEditPlace = (place) => {
        setEditingPlace(place);
    };

    const handleUpdatePlace = async () => {
        try {
            const placeDocRef = doc(db, 'lugar', editingPlace.id);
            await updateDoc(placeDocRef, editingPlace);
            setPlaces(places.map(place => (place.id === editingPlace.id ? editingPlace : place)));
            setEditingPlace(null);
        } catch (error) {
            console.error('Error actualizando el documento: ', error);
        }
    };

    const handleCancelEditPlace = () => {
        setEditingPlace(null);
    };

    const handleAddSpace = async () => {
        if (spaceImages.length > 2) {
            toast.error("Puedes subir un máximo de 2 imágenes por espacio.");
            return;
        }

        let imageUrls = [];
        for (let i = 0; i < spaceImages.length; i++) {
            const image = spaceImages[i];
            const storageRef = ref(storage, `imgEspacios/${image.name}`);
            const uploadTask = uploadBytesResumable(storageRef, image);

            uploadTask.on('state_changed',
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    setProgress(progress);
                },
                (error) => {
                    console.error("Error subiendo la imagen: ", error);
                },
                async () => {
                    const imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
                    imageUrls.push(imageUrl);
                    if (imageUrls.length === spaceImages.length) {
                        await saveSpace(imageUrls);
                    }
                }
            );
        }
    };

    const saveSpace = async (imageUrls) => {
        try {
            const spaceDocRef = await addDoc(collection(db, 'lugar', selectedPlace, 'espacios'), {
                ...newSpace,
                imageUrls
            });
            setSpaces([...spaces, { ...newSpace, id: spaceDocRef.id, imageUrls }]);
            setNewSpace({ nombreEspacio: '', tipo: '', maxPersonas: '', imageUrls: [] });
            setSpaceImages([]);
            setProgress(0);
            setShowSpaceForm(false);
        } catch (error) {
            console.error('Error agregando el espacio: ', error);
        }
    };

    const handleCancelAddSpace = () => {
        setNewSpace({ nombreEspacio: '', tipo: '', maxPersonas: '', imageUrls: [] });
        setSpaceImages([]);
        setShowSpaceForm(false);
    };

    const handleEditSpace = (space) => {
        setEditingSpace(space);
        setNewSpace(space);
        setShowSpaceForm(true);
    };

    const handleUpdateSpace = async () => {
        try {
            const spaceDocRef = doc(db, 'lugar', selectedPlace, 'espacios', editingSpace.id);
            await updateDoc(spaceDocRef, newSpace);
            setSpaces(spaces.map(space => (space.id === editingSpace.id ? newSpace : space)));
            setEditingSpace(null);
            setNewSpace({ nombreEspacio: '', tipo: '', maxPersonas: '', imageUrls: [] });
            setSpaceImages([]);
            setShowSpaceForm(false);
        } catch (error) {
            console.error('Error actualizando el espacio: ', error);
        }
    };

    const handleCancelEditSpace = () => {
        setEditingSpace(null);
        setNewSpace({ nombreEspacio: '', tipo: '', maxPersonas: '', imageUrls: [] });
        setSpaceImages([]);
        setShowSpaceForm(false);
    };

    const handleDeletePlace = async (id) => {
        try {
            await deleteDoc(doc(db, 'lugar', id));
            setPlaces(places.filter(place => place.id !== id));
        } catch (error) {
            console.error('Error eliminando el documento: ', error);
        }
    };

    const handleDeleteSpace = async (placeId, spaceId) => {
        try {
            await deleteDoc(doc(db, 'lugar', placeId, 'espacios', spaceId));
            setSpaces(spaces.filter(space => space.id !== spaceId));
        } catch (error) {
            console.error('Error eliminando el espacio: ', error);
        }
    };
 const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      // Intentamos leer valor guardado en localStorage
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
      }
    } catch (error) {
      // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    // Detectar modo oscuro sistema solo si está disponible window.matchMedia
    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    // Detectar hora nocturna (7pm a 6am)
    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;

    // Retorna true o false seguro
    return prefersDark || isNight;
  });

  // Cargar el tema al inicio (localStorage, sistema u hora)
  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDarkMode(JSON.parse(savedTheme));
    } else {
      // Detecta modo oscuro sistema
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

      // Detecta modo oscuro por hora (7pm - 6am)
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;

      setIsDarkMode(prefersDark || isNight);
    }
  }, []);

  // Guardar la preferencia y aplicar clase al body
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  // Función para cambiar el modo
  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

    return (
        <div>
            <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
            <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
            <ToastContainer />

            <div className="container-mapAd">
                <MapShow 
                    onSelectPlace={handleSelectPlace}
                    onSelectSpace={(space) => setSelectedSpace(space)}
                    onClosePopup={() => setShowSpaceForm(false)}
                />
                <div className="crud-container">
                    <h2>Administrar Ubicaciones</h2>
                    <div className="form">
                        <h3>Crear Nuevo Lugar</h3>
                        <input
                            type="text"
                            name="nombreL"
                            placeholder="Nombre"
                            value={newPlace.nombreL}
                            onChange={handleInputChange}
                        />
                        <input
                            type="text"
                            name="lat"
                            placeholder="Latitud"
                            value={newPlace.lat}
                            onChange={handleInputChange}
                        />
                        <input
                            type="text"
                            name="lon"
                            placeholder="Longitud"
                            value={newPlace.lon}
                            onChange={handleInputChange}
                        />
                        <input
                            type="text"
                            name="referencia"
                            placeholder="Referencia"
                            value={newPlace.referencia}
                            onChange={handleInputChange}
                        />
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                        />
                        <button onClick={handleAddPlace}>Agregar Ubicación</button>
                        {progress > 0 && <progress value={progress} max="100">{progress}%</progress>}
                    </div>
                    <h3>Lista de Ubicaciones</h3>
                    <div className="places-list">
                        {Array.isArray(places) && places.map((place) => (
                            <div key={place.id} className="place-item">
                                <span onClick={() => handleSelectPlace(place)}>{place.nombreL} - {place.referencia}</span>
                                <button onClick={() => handleDeletePlace(place.id)}>Eliminar</button>
                                <button onClick={() => handleEditPlace(place)}>Editar Información</button>
                                {selectedPlace === place.id && (
                                    <div className="spaces-list">
                                        <h4>Espacios</h4>
                                        {Array.isArray(spaces) && spaces.map((space) => (
                                            <div key={space.id}>
                                                <span>{space.nombreEspacio} - {space.tipo}</span>
                                                <button onClick={() => handleEditSpace(space)}>Editar</button>
                                                <button onClick={() => handleDeleteSpace(place.id, space.id)}>Eliminar</button>
                                            </div>
                                        ))}
                                        {!showSpaceForm && (
                                            <button onClick={() => setShowSpaceForm(true)}>Agregar Nuevo Espacio</button>
                                        )}
                                        {showSpaceForm && (
                                            <div className="space-form">
                                                <h3>{editingSpace ? 'Editar Espacio' : 'Agregar Nuevo Espacio'}</h3>
                                                <input
                                                    type="text"
                                                    name="nombreEspacio"
                                                    placeholder="Nombre del Espacio"
                                                    value={newSpace.nombreEspacio}
                                                    onChange={handleSpaceInputChange}
                                                />
                                                <input
                                                    type="text"
                                                    name="tipo"
                                                    placeholder="Tipo"
                                                    value={newSpace.tipo}
                                                    onChange={handleSpaceInputChange}
                                                />
                                                <input
                                                    type="number"
                                                    name="maxPersonas"
                                                    placeholder="Máximo de Personas"
                                                    value={newSpace.maxPersonas}
                                                    onChange={handleSpaceInputChange}
                                                />
                                                <input
                                                    type="file"
                                                    multiple
                                                    accept="image/*"
                                                    onChange={handleSpaceImageChange}
                                                />
                                                <button onClick={editingSpace ? handleUpdateSpace : handleAddSpace}>
                                                    {editingSpace ? 'Actualizar Espacio' : 'Añadir Espacio'}
                                                </button>
                                                <button onClick={editingSpace ? handleCancelEditSpace : handleCancelAddSpace}>
                                                    Cancelar
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    {editingPlace && (
                        <div className="edit-form">
                            <h3>Editar Información del Lugar</h3>
                            <input
                                type="text"
                                name="nombreL"
                                placeholder="Nombre"
                                value={editingPlace.nombreL}
                                onChange={(e) => setEditingPlace({ ...editingPlace, nombreL: e.target.value })}
                            />
                            <input
                                type="text"
                                name="lat"
                                placeholder="Latitud"
                                value={editingPlace.lat}
                                onChange={(e) => setEditingPlace({ ...editingPlace, lat: e.target.value })}
                            />
                            <input
                                type="text"
                                name="lon"
                                placeholder="Longitud"
                                value={editingPlace.lon}
                                onChange={(e) => setEditingPlace({ ...editingPlace, lon: e.target.value })}
                            />
                            <input
                                type="text"
                                name="referencia"
                                placeholder="Referencia"
                                value={editingPlace.referencia}
                                onChange={(e) => setEditingPlace({ ...editingPlace, referencia: e.target.value })}
                            />
                            <button onClick={handleUpdatePlace}>Actualizar Información</button>
                            <button onClick={handleCancelEditPlace}>Cancelar</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MapAd;
